import { addEventSchema } from "../utils/formValidationSchema";
import {
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Radio,
  RadioGroup,
  Stack,
  Textarea,
} from "@chakra-ui/react";
import { Form, Formik } from "formik";
import httpRequest from "../utils/httpRequest";
import { BASE_URL } from "../config/settings";
import { useDispatch } from "react-redux";
import { addEvent } from "../redux/slices/eventSlice";
import { setFormModal } from "../redux/slices/modalSlice";
import { useState } from "react";
import UploadButton from "./UploadButton";

const initialValues = {
  name: "",
  eventType: "",
  eventTime: "",
  startDate: "",
  endDate: "",
  information: "",
  image: null,
  location: "",
  isPaid: false,
  earlyBirdStartDate: "",
  earlyBirdEndDate: "",
  midBirdStartDate: "",
  midBirdEndDate: "",
  lateBirdStartDate: "",
  lateBirdEndDate: "",
  eventCategory: "",
};

const AddEvent = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (values) => {
    const formData = new FormData();
    formData.append("Id", 0);
    formData.append("Name", values.name);
    formData.append("EventType", values.eventType);
    formData.append("StartDate", values.startDate);
    formData.append("EndDate", values.endDate);
    formData.append("EventTime", values.eventTime);
    formData.append("Location", values.location);
    formData.append("Information", values.information);
    formData.append("CoverImage", values.image);
    formData.append("IsPaid", values.isPaid);
    formData.append("EarlyBirdStartDate", values.earlyBirdStartDate);
    formData.append("EarlyBirdEndDate", values.earlyBirdEndDate);
    formData.append("MidBirdStartDate", values.midBirdStartDate);
    formData.append("MidBirdEndDate", values.midBirdEndDate);
    formData.append("LateBirdStartDate", values.lateBirdStartDate);
    formData.append("LateBirdEndDate", values.lateBirdEndDate);
    formData.append("EventCategory", values.eventCategory);

    setIsLoading(true);
    try {
      const response = await httpRequest(
        `${BASE_URL}/EventManagement/create-event`,
        "post",
        formData,
        null,
        "multipart/form-data"
      );

      dispatch(addEvent(response.data));
      dispatch(setFormModal({ status: null }));
    } catch (error) {
      console.log({ error });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={addEventSchema}
      onSubmit={handleSubmit}
    >
      {({
        errors,
        touched,
        values,
        handleBlur,
        handleChange,
        setFieldValue,
      }) => (
        <Flex direction="column" rowGap={4} as={Form}>
          <FormControl isInvalid={errors.name && touched.name}>
            <FormLabel>Event Name</FormLabel>
            <Input
              placeholder="Enter Here"
              fontSize={"small"}
              bg={"#F3F3F3"}
              name="name"
              focusBorderColor="#ffffff"
              borderRadius={"0"}
              borderColor={"#FFFFFF"}
              _placeholder={{ color: "#B4B1B1" }}
              _hover={{ borderColor: "#FFFFFF" }}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values?.name}
            />
            {touched.name && errors.name && (
              <FormErrorMessage>{errors.name}</FormErrorMessage>
            )}
          </FormControl>
          <FormControl isInvalid={errors.isPaid}>
            <FormLabel>Free or Paid Event?</FormLabel>
            <RadioGroup
              onChange={(value) => setFieldValue("isPaid", value === "true")}
              value={values.isPaid === true ? "true" : "false"}
            >
              <Stack direction="row">
                <Radio value="true">Paid</Radio>
                <Radio value="false">Free</Radio>
              </Stack>
            </RadioGroup>
            {touched.isPaid && errors.isPaid && (
              <FormErrorMessage>{errors.isPaid}</FormErrorMessage>
            )}
          </FormControl>
          <FormControl isInvalid={errors.eventType && touched.eventType}>
            <FormLabel>Event Type</FormLabel>
            <Input
              placeholder="Enter Here"
              fontSize={"small"}
              bg={"#F3F3F3"}
              name="eventType"
              focusBorderColor="#ffffff"
              borderRadius={"0"}
              borderColor={"#FFFFFF"}
              _placeholder={{ color: "#B4B1B1" }}
              _hover={{ borderColor: "#FFFFFF" }}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values?.eventType}
            />
            {touched.eventType && errors.eventType && (
              <FormErrorMessage>{errors.eventType}</FormErrorMessage>
            )}
          </FormControl>
          <FormControl
            isInvalid={errors.eventCategory && touched.eventCategory}
          >
            <FormLabel>Event Category</FormLabel>
            <Input
              placeholder="Enter Here"
              fontSize={"small"}
              bg={"#F3F3F3"}
              name="eventCategory"
              focusBorderColor="#ffffff"
              borderRadius={"0"}
              borderColor={"#FFFFFF"}
              _placeholder={{ color: "#B4B1B1" }}
              _hover={{ borderColor: "#FFFFFF" }}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values?.eventCategory}
            />
            {touched.eventCategory && errors.eventCategory && (
              <FormErrorMessage>{errors.eventCategory}</FormErrorMessage>
            )}
          </FormControl>
          <Flex columnGap={2}>
            <FormControl isInvalid={errors.startDate && touched.startDate}>
              <FormLabel>Start Date</FormLabel>
              <Input
                placeholder="Enter Here"
                fontSize={"small"}
                bg={"#F3F3F3"}
                name="startDate"
                focusBorderColor="#ffffff"
                borderRadius={"0"}
                borderColor={"#FFFFFF"}
                _placeholder={{ color: "#B4B1B1" }}
                _hover={{ borderColor: "#FFFFFF" }}
                type="date"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values?.startDate}
              />
              {touched.startDate && errors.startDate && (
                <FormErrorMessage>{errors.startDate}</FormErrorMessage>
              )}
            </FormControl>
            <FormControl isInvalid={errors.endDate && touched.endDate}>
              <FormLabel>End Date</FormLabel>
              <Input
                placeholder="Enter Here"
                fontSize={"small"}
                bg={"#F3F3F3"}
                name="endDate"
                focusBorderColor="#ffffff"
                borderRadius={"0"}
                borderColor={"#FFFFFF"}
                _placeholder={{ color: "#B4B1B1" }}
                _hover={{ borderColor: "#FFFFFF" }}
                type="date"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values?.endDate}
              />
              {touched.endDate && errors.endDate && (
                <FormErrorMessage>{errors.endDate}</FormErrorMessage>
              )}
            </FormControl>
          </Flex>
          <FormControl isInvalid={errors.eventTime && touched.eventTime}>
            <FormLabel>Event Time</FormLabel>
            <Input
              placeholder="Enter Here"
              fontSize={"small"}
              bg={"#F3F3F3"}
              name="eventTime"
              focusBorderColor="#ffffff"
              borderRadius={"0"}
              borderColor={"#FFFFFF"}
              _placeholder={{ color: "#B4B1B1" }}
              _hover={{ borderColor: "#FFFFFF" }}
              type="time"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values?.eventTime}
            />
            {touched.eventTime && errors.eventTime && (
              <FormErrorMessage>{errors.eventTime}</FormErrorMessage>
            )}
          </FormControl>
          <FormControl isInvalid={errors.information && touched.information}>
            <FormLabel>Description</FormLabel>
            <Textarea
              placeholder="Enter Here"
              fontSize={"small"}
              bg={"#F3F3F3"}
              name="information"
              focusBorderColor="#ffffff"
              borderRadius={"0"}
              borderColor={"#FFFFFF"}
              _placeholder={{ color: "#B4B1B1" }}
              _hover={{ borderColor: "#FFFFFF" }}
              onBlur={handleBlur}
              onChange={handleChange}
              rows={5}
              resize={"none"}
              value={values?.information}
            />
            {touched.information && errors.information && (
              <FormErrorMessage>{errors.information}</FormErrorMessage>
            )}
          </FormControl>
          <FormControl isInvalid={errors.location && touched.location}>
            <FormLabel>Location</FormLabel>
            <Input
              placeholder="Enter Here"
              fontSize={"small"}
              bg={"#F3F3F3"}
              name="location"
              focusBorderColor="#ffffff"
              borderRadius={"0"}
              borderColor={"#FFFFFF"}
              _placeholder={{ color: "#B4B1B1" }}
              _hover={{ borderColor: "#FFFFFF" }}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values?.location}
            />
            {touched.location && errors.location && (
              <FormErrorMessage>{errors.location}</FormErrorMessage>
            )}
          </FormControl>
          {/* Early Bird */}
          <Flex columnGap={2}>
            <FormControl
              isInvalid={
                errors.earlyBirdStartDate && touched.earlyBirdStartDate
              }
            >
              <FormLabel>Early Bird Start Date</FormLabel>
              <Input
                placeholder="Enter Here"
                fontSize={"small"}
                bg={"#F3F3F3"}
                name="earlyBirdStartDate"
                focusBorderColor="#ffffff"
                borderRadius={"0"}
                borderColor={"#FFFFFF"}
                _placeholder={{ color: "#B4B1B1" }}
                _hover={{ borderColor: "#FFFFFF" }}
                type="date"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values?.earlyBirdStartDate}
              />
              {touched.earlyBirdStartDate && errors.earlyBirdStartDate && (
                <FormErrorMessage>{errors.earlyBirdStartDate}</FormErrorMessage>
              )}
            </FormControl>
            <FormControl
              isInvalid={errors.earlyBirdEndDate && touched.earlyBirdEndDate}
            >
              <FormLabel>Early Bird End Date</FormLabel>
              <Input
                placeholder="Enter Here"
                fontSize={"small"}
                bg={"#F3F3F3"}
                name="earlyBirdEndDate"
                focusBorderColor="#ffffff"
                borderRadius={"0"}
                borderColor={"#FFFFFF"}
                _placeholder={{ color: "#B4B1B1" }}
                _hover={{ borderColor: "#FFFFFF" }}
                type="date"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values?.earlyBirdEndDate}
              />
              {touched.earlyBirdEndDate && errors.earlyBirdEndDate && (
                <FormErrorMessage>{errors.earlyBirdEndDate}</FormErrorMessage>
              )}
            </FormControl>
          </Flex>
          {/* Mid Bird */}
          <Flex columnGap={2}>
            <FormControl
              isInvalid={errors.midBirdStartDate && touched.midBirdStartDate}
            >
              <FormLabel>Mid Bird Start Date</FormLabel>
              <Input
                placeholder="Enter Here"
                fontSize={"small"}
                bg={"#F3F3F3"}
                name="midBirdStartDate"
                focusBorderColor="#ffffff"
                borderRadius={"0"}
                borderColor={"#FFFFFF"}
                _placeholder={{ color: "#B4B1B1" }}
                _hover={{ borderColor: "#FFFFFF" }}
                type="date"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values?.midBirdStartDate}
              />
              {touched.midBirdStartDate && errors.midBirdStartDate && (
                <FormErrorMessage>{errors.midBirdStartDate}</FormErrorMessage>
              )}
            </FormControl>
            <FormControl
              isInvalid={errors.midBirdEndDate && touched.midBirdEndDate}
            >
              <FormLabel>Mid Bird End Date</FormLabel>
              <Input
                placeholder="Enter Here"
                fontSize={"small"}
                bg={"#F3F3F3"}
                name="midBirdEndDate"
                focusBorderColor="#ffffff"
                borderRadius={"0"}
                borderColor={"#FFFFFF"}
                _placeholder={{ color: "#B4B1B1" }}
                _hover={{ borderColor: "#FFFFFF" }}
                type="date"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values?.midBirdEndDate}
              />
              {touched.midBirdEndDate && errors.midBirdEndDate && (
                <FormErrorMessage>{errors.midBirdEndDate}</FormErrorMessage>
              )}
            </FormControl>
          </Flex>
          {/* Late Bird */}
          <Flex columnGap={2}>
            <FormControl
              isInvalid={errors.lateBirdStartDate && touched.lateBirdStartDate}
            >
              <FormLabel>Late Bird Start Date</FormLabel>
              <Input
                placeholder="Enter Here"
                fontSize={"small"}
                bg={"#F3F3F3"}
                name="lateBirdStartDate"
                focusBorderColor="#ffffff"
                borderRadius={"0"}
                borderColor={"#FFFFFF"}
                _placeholder={{ color: "#B4B1B1" }}
                _hover={{ borderColor: "#FFFFFF" }}
                type="date"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values?.lateBirdStartDate}
              />
              {touched.lateBirdStartDate && errors.lateBirdStartDate && (
                <FormErrorMessage>{errors.lateBirdStartDate}</FormErrorMessage>
              )}
            </FormControl>
            <FormControl
              isInvalid={errors.lateBirdEndDate && touched.lateBirdEndDate}
            >
              <FormLabel>Late Bird End Date</FormLabel>
              <Input
                placeholder="Enter Here"
                fontSize={"small"}
                bg={"#F3F3F3"}
                name="lateBirdEndDate"
                focusBorderColor="#ffffff"
                borderRadius={"0"}
                borderColor={"#FFFFFF"}
                _placeholder={{ color: "#B4B1B1" }}
                _hover={{ borderColor: "#FFFFFF" }}
                type="date"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values?.lateBirdEndDate}
              />
              {touched.lateBirdEndDate && errors.lateBirdEndDate && (
                <FormErrorMessage>{errors.lateBirdEndDate}</FormErrorMessage>
              )}
            </FormControl>
          </Flex>
          <FormControl isInvalid={errors.image}>
            <FormLabel>File input</FormLabel>
            {/* <ImageUpload /> */}
            <Input
              name="image"
              type="file"
              height="100%"
              width="100%"
              position="absolute"
              top="0"
              left="0"
              opacity="0"
              aria-hidden="true"
              accept="image/*"
              onChange={(e) => {
                setFieldValue("image", e.target.files[0]);
              }}
              onBlur={handleBlur}
            />
            {values.image ? (
              <div>
                <img src={URL.createObjectURL(values.image)} alt="Selected" />
              </div>
            ) : (
              <UploadButton />
            )}
            {touched.image && errors.image && (
              <FormErrorMessage>{errors.image}</FormErrorMessage>
            )}
          </FormControl>
          <Button
            mt={10}
            width={"100%"}
            background={"#22944E"}
            _hover={{ background: " " }}
            color={"#FFFFFF"}
            type="submit"
            isLoading={isLoading}
            loadingText="...Adding Event"
          >
            Save
          </Button>
        </Flex>
      )}
    </Formik>
  );
};

export default AddEvent;
